/**
 * PostureMinder — posture-reminder tool
 *
 * Declares a single web-accessible-resource — `audio/notification.mp3` — matched to
 * every origin with no `use_dynamic_url`, so the reminder sound is fetchable from any
 * page at a fixed URL. It is the extension's only exposed resource.
 *
 * The manifest writes the path as `./audio/notification.mp3`; Chrome normalises the
 * leading `./` away, so the resource resolves at `audio/notification.mp3`. A successful
 * fetch there is conclusive — the file is served only when the extension is installed.
 *
 * Manifest verified against version 2.1.3.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dkmkfopiihabelocpelofchappjjnpkm';

export const postureMinder: ExtensionDefinition = {
  id: ID,
  name: 'PostureMinder',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 20_000,
  notes:
    'Single WAR (audio/notification.mp3) exposed to every origin with no dynamic URL. ' +
    'One fetch is conclusive.',
  signals: [
    {
      id: 'war-notification-mp3',
      kind: 'web-accessible-resource',
      description:
        'Fetch audio/notification.mp3 — the reminder sound, the only web-accessible ' +
        'resource, exposed to every origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'audio/notification.mp3'),
    },
  ],
};
